<template>
    <!-- PC -->
    <div v-if="!mobile">
        <div>
            <div class="lkt-manual env_VN">
                <div><img src="/static\images\vi\newManual\changeLanguageManual-1.png" alt="" /></div>
                <div>
                    <p>Nhấn vào biểu tượng quốc kỳ ở thanh menu chính của phần trên màn hình, rồi chọn 1 trong 4 ngôn ngữ được hiển thị.</p>
                </div>
            </div>
        </div>
    </div>
    <!-- Mobile -->
    <div v-else>
        <div>
            <div class="lkt-manual env_VN">
                <h1>Mobile</h1>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {};
        },
        components: {},
        computed: {
            mobile() {
                return this.$store.getters["header/mobile"];
            },
        },
        async created() {},
        watch: {},
        methods: {},
    };
</script>
<style scoped>
    .lkt-manual div {
        margin-bottom: 10px;
    }
    .lkt-manual p {
        line-height: 25px;
    }
    img {
        width: 100%;
    }
    p {
        font-size: 16px;
    }
</style>



// WEBPACK FOOTER //
// src/components/manual/content/en/changeLanguage_manual.vue